import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Disc, Play, ChevronRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DVDsPage() {
  const [dvds, setDvds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDvds = async () => {
      try {
        const res = await axios.get(`${API}/dvds`);
        setDvds(res.data);
      } catch (e) {
        console.error("Erro ao buscar DVDs:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchDvds();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505]">
        <Header />
        <main className="pt-24 max-w-7xl mx-auto px-4">
          <div className="animate-pulse text-center text-zinc-500 py-20">Carregando DVDs...</div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
      <main className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6" data-testid="dvds-page">
        <div className="flex items-center gap-3 mb-8">
          <Disc className="text-[#FF007F]" size={28} />
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white">DVDs & Vídeos</h1>
        </div>

        {dvds.length === 0 ? (
          <p className="text-zinc-500 text-center py-20">Nenhum DVD disponível no momento.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {dvds.map((dvd) => (
              <Link
                key={dvd.id}
                to={`/dvd/${dvd.id}`}
                className="group block bg-[#121212] rounded-2xl overflow-hidden border border-white/10 card-hover"
                data-testid={`dvd-card-${dvd.id}`}
              >
                <div className="relative w-full overflow-hidden bg-[#0a0a0a]">
                  {dvd.cover_image ? (
                    <img
                      src={dvd.cover_image}
                      alt={dvd.title}
                      className="w-full object-contain transition-transform duration-500 group-hover:scale-105"
                      style={{ maxHeight: "400px", minHeight: "200px" }}
                    />
                  ) : (
                    <div className="w-full h-48 flex items-center justify-center bg-gradient-to-br from-[#1a1a2e] to-[#0f3460]">
                      <Disc size={48} className="text-[#FF007F]/50" />
                    </div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/40">
                    <div className="w-16 h-16 rounded-full bg-[#FF007F] flex items-center justify-center">
                      <Play size={28} fill="white" className="text-white ml-1" />
                    </div>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#FF007F] text-white text-xs font-bold px-3 py-1 rounded-full">DVD</span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold text-white mb-1 group-hover:text-[#FF007F] transition-colors">
                    {dvd.title}
                  </h3>
                  <p className="text-zinc-400 text-sm mb-3">{dvd.artist_name}</p>
                  {dvd.description && (
                    <p className="text-zinc-500 text-xs line-clamp-2">{dvd.description}</p>
                  )}
                  <div className="flex items-center gap-1 mt-3 text-[#FF007F] text-sm font-medium">
                    Assistir <ChevronRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
